import type { AuthConfig } from '../types';

const LEGACY_SCOPES = 'openid profile email create-proj-api offline_access';

/** Configured scopes are authoritative, not additions to the old shared API. */
export function authScopes(config: Pick<AuthConfig, 'scopes'>): string {
  if (config.scopes == null) return LEGACY_SCOPES;
  // RFC 6749 scope-token excludes quotes, backslashes and control characters.
  const value = config.scopes.trim();
  if (!/^[\x21\x23-\x5B\x5D-\x7E]+(?: +[\x21\x23-\x5B\x5D-\x7E]+)*$/.test(value)) {
    throw new Error('Invalid login scope configuration. Contact the deployment administrator.');
  }
  const scopes = [...new Set(value.split(/ +/))];
  if (!scopes.includes('openid')) {
    throw new Error('Login configuration is missing the openid scope. Contact the deployment administrator.');
  }
  return scopes.join(' ');
}
